// dependancies
import React, { Component } from "react";
import PropTypes from "prop-types";

// components
import NotFound from "shared-anpost-components/components/notFound/NotFound";

/**
 * When an error occurs is development mode the stack
 * trace is printed to the console. In production however
 * the entire component tree is unmounted and the user is
 * shown a black screen. If an error accurs this component
 * is mounted instead.
 */
export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { errorOccurred: false }; // set error state to false by default
    }

    componentDidCatch() {
        this.setState({ errorOccurred: true }); // if an error is caught set errorOccurred to true
    }

    render() {
        const { errorOccurred } = this.state;
        const { children } = this.props;
        return errorOccurred ? <NotFound /> : children;
    }
}

// props validation
ErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired
};
